import {
  IBulkPayableBatch,
  IBulkPayableBatchCreate,
  IBulkPayableBatchUpdate
} from "@wingspanhq/payments/dist/interfaces";
import { useWSMutation } from "../../../../../query/helpers";
import { WSServiceError } from "../../../../../utils/serviceHelper";
import {
  QUERY_BULK_PAYABLE_BATCH,
  QUERY_BULK_PAYABLE_BATCH_LIST,
  QUERY_BULK_PAYABLE_BATCH_SUMMARY
} from "./keys";
import { bulkPayableService } from "../../services/bulkPayable";

export const useMutationCreateBulkPayableBatch = () =>
  useWSMutation(
    (data: IBulkPayableBatchCreate) => bulkPayableService.batch.create(data),
    {
      dependencies: [QUERY_BULK_PAYABLE_BATCH_LIST]
    }
  );

export const useMutationUpdateBulkPayableBatch = () =>
  useWSMutation(
    (payload: { id: string; data: IBulkPayableBatchUpdate }) =>
      bulkPayableService.batch.update(payload.id, payload.data),
    {
      dependencies: [QUERY_BULK_PAYABLE_BATCH, QUERY_BULK_PAYABLE_BATCH_SUMMARY]
    }
  );

export const useMutationDeleteBulkPayableBatch = () => {
  return useWSMutation<
    IBulkPayableBatch,
    WSServiceError,
    {
      bulkBatchId: string;
    }
  >(
    async ({ bulkBatchId }) => {
      return await bulkPayableService.batch.delete(bulkBatchId);
    },
    {
      dependencies: [QUERY_BULK_PAYABLE_BATCH_LIST]
    }
  );
};
